import { useCustomAttributesSidePanel } from 'src/graphql/entities/custom-attributes/side-panel-context';
import { SidePanelRowProps } from 'src/graphql/entities/side-panel-personalization';
import { CustomAttributeRow } from './custom-attribute-row';

export const CustomAttributeSidePanelRow = ({ propertyKey }: SidePanelRowProps) => {
  const { rowsByPropertyKey, onSave, disabled } = useCustomAttributesSidePanel();

  const row = rowsByPropertyKey.get(propertyKey);

  if (!row) {
    return null;
  }

  return <CustomAttributeRow row={row} onSave={onSave} disabled={disabled} />;
};
